exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".apply .wrapper .application .app-display .left-side .info .inputs .check-buttons .check-container{display:flex}.check-container .jq-checkbox.app-checkbox{flex:1;margin-right:10px;max-width:15px}.apply .wrapper .application .app-display .left-side .info .inputs .check-buttons .check-container .jq-checkbox.checked:after{width:5px;height:12px}.apply .wrapper .application .app-display .left-side .info .inputs label{left:40px;padding-top:2px;flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./directives/freeforms/checkbox/checkbox.css
// module id = 408
// module chunks = 0